import {createSlice} from '@reduxjs/toolkit'
import { ARCHIVE_ALL_APPLICATIONS_URL, ARCHIVE_APPLICATION_URL } from '../../app/constants'

const archiveApplicationsSlice = createSlice({
    name : 'archiveApplications',
    initialState : {
        applications: [],
    },
    reducers : {
        addArchiveApplications(state, action) {
            state.applications = [
                ...state.applications, 
                ...action.payload.businessLicenceList
            ]
        },
    }
})

export const {
    addArchiveApplications
} = archiveApplicationsSlice.actions

export const fetchArchiveApplicationsForOriginalId = (originalApplicationId) => async (dispatch, getState) => {
    let param = originalApplicationId
    
    if(Array.isArray(originalApplicationId)) {
        param = originalApplicationId.join(",")
    }

    const url = ARCHIVE_APPLICATION_URL + "?originalApplicationId=" + param
    return fetch(url)
            .then(resp => resp.json())
            .then(data => {
                dispatch(addArchiveApplications(data))
                return data.businessLicenceList
            })
}

export const postArchiveAllApplications = (primaryAgencyApplicationId) => async (dispatch, getState) => {
    const {csrfToken} = getState().userAuth
    const url = ARCHIVE_ALL_APPLICATIONS_URL + "?primaryAgencyApplicationId=" + primaryAgencyApplicationId

    let headers = new Headers()
    headers.append('Content-Type',"application/json")
    headers.append("X-CSRF-TOKEN", csrfToken)
    
    return fetch(url,{ method : "POST", headers: headers})
            .then(resp => resp.json())
            .then(data => {
                return data
            })
}

export default archiveApplicationsSlice.reducer